(function () {
  'use strict';

  function parseBoolean(value) {
    return String(value).toLowerCase() === 'true';
  }

  function text(root, selector, value) {
    var element = root.querySelector(selector);
    if (element) element.textContent = value;
  }

  function syncHeaderOverlap(root) {
    if (!root) return;
    root.style.setProperty('--club-header-overlap', '0px');

    window.requestAnimationFrame(function () {
      var rootTop = root.getBoundingClientRect().top;
      var overlapBottom = rootTop;
      var selectors = [
        'header',
        '.shopify-section.header-section',
        '[data-section-type="header"]',
        '[data-section-type="announcement-bar"]'
      ];

      document.querySelectorAll(selectors.join(',')).forEach(function (element) {
        if (element === root || element.contains(root)) return;
        var style = window.getComputedStyle(element);
        if (style.position !== 'fixed' && style.position !== 'sticky') return;
        var rect = element.getBoundingClientRect();
        if (rect.width < window.innerWidth * 0.45 || rect.height <= 0) return;
        if (rect.top > rootTop + 2 || rect.bottom <= rootTop) return;
        if (rect.bottom > window.innerHeight * 0.65) return;
        overlapBottom = Math.max(overlapBottom, rect.bottom);
      });

      root.style.setProperty(
        '--club-header-overlap',
        Math.max(0, Math.ceil(overlapBottom - rootTop)) + 'px'
      );
    });
  }

  function openModal(root) {
    var modal = root.querySelector('[data-club-modal]');
    if (!modal) return;
    modal.hidden = false;
    document.documentElement.classList.add('pct-club-modal-open');
    var closeButton = modal.querySelector('[data-club-close]');
    if (closeButton) closeButton.focus();
  }

  function closeModal(root) {
    var modal = root.querySelector('[data-club-modal]');
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('pct-club-modal-open');
    var redeemButton = root.querySelector('[data-club-redeem]');
    if (redeemButton) redeemButton.focus();
  }

  function setFeedback(root, message, isError) {
    var feedback = root.querySelector('[data-club-feedback]');
    if (!feedback) return;
    feedback.textContent = message || '';
    feedback.style.color = isError ? '#a12622' : '';
  }

  function openIntegratedCartAfterDiscount() {
    var currentUrl;
    try {
      currentUrl = new URL(window.location.href);
    } catch (error) {
      return;
    }

    if (currentUrl.searchParams.get('club_open_cart') !== '1') return;

    currentUrl.searchParams.delete('club_open_cart');
    if (window.history && window.history.replaceState) {
      window.history.replaceState(
        {},
        document.title,
        currentUrl.pathname + currentUrl.search + currentUrl.hash
      );
    }

    var attempts = 0;
    function openCart() {
      var toggles = Array.prototype.slice.call(document.querySelectorAll('.cart-toggle'));
      var cartToggle = toggles.find(function (element) {
        return element.offsetParent !== null;
      }) || toggles[0];

      if (cartToggle) {
        cartToggle.click();
        return;
      }

      attempts += 1;
      if (attempts < 20) window.setTimeout(openCart, 100);
    }

    window.setTimeout(openCart, 700);
  }

  function discountUrlReturningToIntegratedCart(discountUrl) {
    var url = new URL(discountUrl, window.location.origin);
    url.searchParams.set('redirect', window.location.pathname + '?club_open_cart=1');
    return url.pathname + url.search + url.hash;
  }

  function formatMonth(value) {
    if (!/^\d{4}-\d{2}$/.test(value || '')) return value || '';
    var parts = value.split('-');
    return parts[1] + '/' + parts[0];
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatHistoryKind(entry) {
    var names = {
      order_earned: 'Commande enregistrée',
      review_earned: 'Avis Judge.me vérifié',
      manual_adjustment: 'Ajustement du service client',
      cwill_migration: 'Points de l’ancien programme convertis',
      order_reversed: 'Commande annulée ou remboursée',
      redemption_reserved: 'Remise Club Procleantools',
      redemption_used: 'Remise Club Procleantools utilisée',
      redemption_released: 'Bon remis dans votre stock',
      voucher_expired: 'Bon Club Procleantools expiré'
    };
    if (entry.kind === 'cwill_migration' || entry.source_type === 'cwill_import') {
      return names.cwill_migration;
    }
    return entry.note || names[entry.kind] || 'Mouvement de points';
  }

  function renderHistory(root, history) {
    var container = root.querySelector('[data-club-history]');
    if (!container || !Array.isArray(history)) return;
    if (!history.length) {
      container.innerHTML = '<p class="pct-club__empty">Votre historique apparaîtra ici après votre première activité éligible.</p>';
      return;
    }

    container.innerHTML = history.map(function (entry) {
      var points = Number(entry.points || 0);
      var date = new Date(entry.created_at);
      var dateText = Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString('fr-FR');
      return '<div class="pct-club__history-row">' +
        '<span class="pct-club__history-icon" aria-hidden="true">' + (points >= 0 ? '+' : '−') + '</span>' +
        '<div><strong>' + escapeHtml(formatHistoryKind(entry)) + '</strong><span>' + escapeHtml(dateText) + '</span></div>' +
        '<b>' + (points > 0 ? '+' : '') + points + ' pts</b>' +
      '</div>';
    }).join('');
  }

  function refreshRedeem(root, summary) {
    var rules = summary.rules || {};
    var rewardCents = Number(rules.reward_cents || 500);
    var vouchersAvailable = Math.max(0, Number(summary.vouchers_available || 0));
    var cartSubtotal = Math.max(0, Number(root.dataset.cartSubtotalCents || 0));
    var stepsByCart = Math.floor(cartSubtotal / (rewardCents * 10));
    var steps = Math.min(vouchersAvailable, stepsByCart);
    var amountCents = steps * rewardCents;
    var euros = (amountCents / 100).toLocaleString('fr-FR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });

    root.dataset.redeemSteps = String(steps);
    root.dataset.usableEuros = String(amountCents / 100);

    var empty = root.querySelector('[data-club-redeem-empty]');
    var ready = root.querySelector('[data-club-redeem-ready]');
    var emptyText = root.querySelector('[data-club-redeem-empty-text]');
    if (empty) empty.hidden = steps > 0;
    if (ready) ready.hidden = steps <= 0;
    if (emptyText) {
      emptyText.textContent = cartSubtotal <= 0
        ? 'Ajoutez des produits au panier pour calculer la remise utilisable.'
        : 'Votre stock de bons ou le montant du panier ne permet pas encore d’utiliser un bon de 5 €.';
    }
    text(root, '[data-club-redeem-amount]', euros + ' € HT');
    text(root, '[data-club-redeem-points]', steps + ' bon' + (steps > 1 ? 's seront utilisés' : ' sera utilisé'));
    text(root, '[data-club-redeem-button-amount]', euros + ' € HT');
  }

  function hydrateAccount(root, summary) {
    var rules = summary.rules || {};
    var rewardPoints = Number(rules.reward_points || 250);
    var rewardCents = Number(rules.reward_cents || 500);
    var reviewLimit = Number(rules.review_monthly_limit || 10);
    var available = Number(summary.points_available || 0);
    var progressPoints = Number(summary.progress_points || 0);
    var progressPercent = Math.max(0, Math.min(100, progressPoints * 100 / rewardPoints));
    var reviewCount = Number(summary.rewarded_reviews_month || 0);
    var reviewPercent = Math.max(0, Math.min(100, reviewCount * 100 / reviewLimit));
    var vouchersAvailable = Number(summary.vouchers_available || 0);
    var rewardEuros = Number(summary.voucher_value_cents || 0) / 100;

    root.dataset.points = String(available);
    text(root, '[data-club-points]', available);
    text(root, '[data-club-pending]', Number(summary.points_pending || 0));
    text(root, '[data-club-lifetime]', Number(summary.points_lifetime || 0));
    text(root, '[data-club-vouchers]', vouchersAvailable);
    text(root, '[data-club-voucher-value]', 'Soit ' + rewardEuros.toLocaleString('fr-FR') + ' € HT disponibles');
    text(root, '[data-club-reward-value]', 'Les points sont automatiquement convertis dès 250 points');
    var pointsUntilReward = Number(summary.points_until_reward || rewardPoints);
    var nextRewardLabel = 'Encore ' + pointsUntilReward + ' points';
    text(root, '[data-club-next]', nextRewardLabel);
    text(root, '[data-club-progress-current]', progressPoints + ' points');
    text(root, '[data-club-review-count]', reviewCount + ' / ' + reviewLimit);
    text(root, '[data-club-review-month]', 'Avis récompensés en ' + formatMonth(summary.review_month_key));
    text(root, '[data-club-review-points]', '+' + Number(summary.review_points_month || 0) + ' points ce mois-ci');

    var progress = root.querySelector('[data-club-progress]');
    var progressWrap = root.querySelector('[data-club-progress-wrap]');
    if (progress) progress.style.width = progressPercent + '%';
    if (progressWrap) progressWrap.setAttribute('aria-label', progressPoints + ' points sur ' + rewardPoints);
    var reviewProgress = root.querySelector('[data-club-review-progress]');
    var reviewProgressWrap = root.querySelector('[data-club-review-progress-wrap]');
    if (reviewProgress) reviewProgress.style.width = reviewPercent + '%';
    if (reviewProgressWrap) reviewProgressWrap.setAttribute('aria-label', reviewCount + ' avis récompensés sur ' + reviewLimit);

    var migrated = root.querySelector('[data-club-migrated]');
    if (migrated) migrated.hidden = !summary.migrated_from_cwill;
    renderHistory(root, summary.history);
    refreshRedeem(root, summary);
  }

  function loadAccount(root) {
    var endpoint = root.dataset.accountEndpoint;
    if (!endpoint) return Promise.resolve();
    root.setAttribute('aria-busy', 'true');
    return fetch(endpoint, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status === 401 ? 'Connectez-vous pour consulter vos points.' : 'Le solde fidélité est momentanément indisponible.');
        return response.json();
      })
      .then(function (summary) { hydrateAccount(root, summary); })
      .catch(function (error) { setFeedback(root, error.message, true); })
      .finally(function () { root.removeAttribute('aria-busy'); });
  }

  function bindClub(root) {
    if (!root || root.dataset.clubReady === 'true') return;
    root.dataset.clubReady = 'true';
    syncHeaderOverlap(root);

    var testMode = parseBoolean(root.dataset.testMode);
    var redeemButton = root.querySelector('[data-club-redeem]');

    root.querySelectorAll('[data-club-close]').forEach(function (button) {
      button.addEventListener('click', function () { closeModal(root); });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeModal(root);
    });

    if (!testMode) loadAccount(root);
    document.addEventListener('club:vouchers-released', function (event) {
      if (testMode) return;
      loadAccount(root).then(function () {
        var restored = Number(event.detail && event.detail.releasedVouchers || 0);
        if (restored > 0) setFeedback(root, 'Votre bon non consommé est de nouveau disponible.', false);
      });
    });
    if (!redeemButton) return;

    redeemButton.addEventListener('click', function () {
      var steps = Number(root.dataset.redeemSteps || 0);
      if (!steps) {
        setFeedback(root, 'Aucun palier de remise n’est disponible pour ce panier.', true);
        return;
      }
      if (testMode) {
        openModal(root);
        return;
      }

      redeemButton.disabled = true;
      redeemButton.setAttribute('aria-busy', 'true');
      setFeedback(root, 'Préparation de votre remise sécurisée…', false);

      fetch(root.dataset.redeemEndpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ steps: steps })
      })
        .then(function (response) {
          return response.json().then(function (payload) {
            if (!response.ok) throw new Error(payload.error || 'La remise n’a pas pu être créée.');
            return payload;
          });
        })
        .then(function (payload) {
          if (!payload.discount_url) throw new Error('Réponse de remise incomplète.');
          try {
            window.localStorage.setItem('pctClubDiscountReservation', JSON.stringify({
              code: payload.discount_code || '',
              amountCents: Number(payload.amount_cents || 0),
              expiresAt: payload.expires_at || ''
            }));
          } catch (error) {
            // Le panier reste utilisable si le stockage du navigateur est indisponible.
          }
          window.location.assign(discountUrlReturningToIntegratedCart(payload.discount_url));
        })
        .catch(function (error) {
          redeemButton.disabled = false;
          redeemButton.removeAttribute('aria-busy');
          setFeedback(root, error.message || 'Une erreur est survenue. Réessayez dans quelques instants.', true);
        });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-pct-club]').forEach(bindClub);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      openIntegratedCartAfterDiscount();
      init(document);
    });
  } else {
    openIntegratedCartAfterDiscount();
    init(document);
  }
  var resizeTimer;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      document.querySelectorAll('[data-pct-club]').forEach(syncHeaderOverlap);
    }, 120);
  });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
